/* eslint-disable  */

import { IGridBoletim } from 'interfaces/Grid';
import { useState, createContext, useContext } from 'react';

type IGridBoletimContext = {
  boletinsWTG: IGridBoletim[];
  setBoletinsWTG: (boletim: IGridBoletim[]) => void;
};
const BoletimContext = createContext<IGridBoletimContext>(
  {} as IGridBoletimContext,
);

export const BoletimProvider = ({ children }) => {
  const [boletinsWTG, setBoletinsWTG] = useState<IGridBoletim[]>([]);

  return (
    <BoletimContext.Provider value={{ boletinsWTG, setBoletinsWTG }}>
      {children}
    </BoletimContext.Provider>
  );
};
export default function useBoletimContext() {
  const context = useContext(BoletimContext);

  return context;
}
